import { AxiosError, AxiosResponse } from "axios";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { IState } from "../models";
import http from "../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IEmployeeListPayload, IEmployeeRequest, IEmployeeResponse } from '../models/employee';

export const StateService = {
  getState: async (
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<any | IServerError | IResponse | any[]> => {
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        "/v1/states/?order_by=" +
          data.order_by +
          "&order_direction=" +
          data.order_direction +
          "&page=" +
          data.page +
          "&size=" +
          data.size +
          "&search_query=" +
          data.search_query,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getById: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<any | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/states/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  create: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<IState> = await http.put<IState>(
          `/v1/states/${requestPayload.id}/`,
          requestPayload,
        );

        // if (response.status === 200) {
        //   return {
        //     status: true,
        //     message: "Success",
        //     error: false,
        //   };
        // }
        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<IState> = await http.post<IState>(
        "/v1/states/",
        requestPayload,
      );

      // if (response.status === 201) {
      //     return {
      //       status: true,
      //       message: "Success",
      //       error: false,
      //     };
      //   }
      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delState: async (
    delPayload: any,
  ): Promise<any | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<any> = await http.delete<any>(
        `/v1/states/${delPayload.stateId}/`,
      );

      if (response.status === 204) {
        return "State has been deleted successfully";
      } else if (response.status === 200) {
        return "State has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delBulkState: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(`/v1/states/`, {
        data: requestPayload.bulkStateId,
      });
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getStateDDL: async (): Promise<
    any | IServerError | IResponse | null | any
  > => {
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/states/ddl/1/?order_by=name&order_direction=asc&size=50`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
  archiveState: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/state/${archivePayload.stateId}/`,
      );

      if (response.status === 201) {
        return "State has been archived successfully";
      } else if (response.status === 200) {
        return "State has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
};
